export enum AwsServiceType {
  CROSSCOS_CONNECTIONS_COUNTERS = 'crosscos_connections_counters',
  ETREES_IN_OUT_COUNTERS = 'etrees_in_out_counters',
  ETREES_PLR_LAT_VALUES = 'etrees_plr_lat_values',
  ALL = 'all',
}
